import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-alerta',
  templateUrl: './alerta.component.html',
  styleUrls: ['./alerta.component.scss']
})
export class AlertaComponent {
  @Input() tipo: 'success' | 'warning' | 'danger' | 'info';
  @Input() mensaje: string;
  @Input() mostrarIcono: boolean = true;
}
